import { render } from "./SoundOff.vue?vue&type=template&id=6bd8c7c9&scoped=true"
import script from "./SoundOff.vue?vue&type=script&lang=js"
export * from "./SoundOff.vue?vue&type=script&lang=js"

import "./SoundOff.vue?vue&type=style&index=0&id=6bd8c7c9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bd8c7c9"]])

export default __exports__